<template>
    <div class="details_container">
        <img src="@/assets/themeFour/agentGraph.png" alt="" width="100%">
        <div class="qCard">
            <div class="card_details" v-html="$t('agent.definitionContentTheme3')"></div>
        </div>
    </div>
</template>

<script setup lang="ts">


</script>

<style scoped>
.details_container {
    padding: 15px 0;
    background: rgb(0, 53, 52);
}

.qCard {
    border-radius: 10px;
    border: 1px solid rgb(0, 97, 95);
    padding: 5px;
    margin: 5px;
    line-height: 20px;
    color: rgb(255, 255, 255,0.4);
}

.qCard span {
    color: #FFEE00;
}

.title {
    font-size: 16px;
    font-weight: 700;
}

.card_details {
    color: rgb(255, 255, 255,0.4);
    line-height: 15px;
}
</style>